import type { FC } from "react";
import type { SvgIcons } from "../../type/Icons";

export const Speaker: FC<SvgIcons> = ({
  fill,
  width = "32",
  height = "32",
}) => {
  return (
    <>
      <svg
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={width}
        fill={fill ?? "none"}
        className="size-6 transition-transform duration-300 hover:scale-125 text-brand"
      >
        {" "}
        <g fill={fill ?? "currentColor"}>
          {" "}
          <path d="m11.729 11.736 6.959-6.213v20.955l-6.96-6.193-.557-4.284z"></path>{" "}
          <path d="M11.546 16.006a8.6 8.6 0 0 1 .74-3.68.39.39 0 0 0-.338-.59H7.14c-1.694-.007-2.889 1.908-2.889 4.27 0 2.363 1.195 4.279 2.89 4.279h4.815a.391.391 0 0 0 .338-.59 8.6 8.6 0 0 1-.747-3.689M21.434 4.374c3.485 0 6.316 5.193 6.316 11.626s-2.824 11.626-6.316 11.626S15.117 22.433 15.117 16s2.824-11.626 6.317-11.626m1.414 7.692a1.097 1.097 0 0 0-1.538-.117 1.11 1.11 0 0 0-.143 1.552c.5.74.748 1.62.707 2.512.036.89-.21 1.77-.701 2.513a1.095 1.095 0 0 0 .124 1.551c.199.17.452.264.714.266.325-.002.632-.144.844-.39a6.3 6.3 0 0 0 1.227-3.94 6.24 6.24 0 0 0-1.234-3.947"></path>{" "}
        </g>{" "}
      </svg>
    </>
  );
};
